import { PreviewHTML } from './types';

export const PREVIEW_FORM_FIELDS_WIDTH = 360;

export const ENTITY_TYPE = {
  VIDEO: 'video',
  EVENT: 'event',
  SHOWCASE: 'album',
} as const;

export const ENTITY_TO_PATH_MAP = {
  [ENTITY_TYPE.VIDEO]: 'videos',
  [ENTITY_TYPE.EVENT]: 'live_events',
  [ENTITY_TYPE.SHOWCASE]: 'albums',
} as const;

export const FORM_LAYOUT_OPTIONS = {
  MULTI_STEP_FORM: 'multi_step',
  SINGLE_STEP_FORM: 'single_step',
} as const;

export const VIDEO_PLACEMENT = {
  BEFORE: 'before_video',
  DURING: 'during_video',
  AFTER: 'after_video',
} as const;

export const BACKGROUND_STYLE = {
  FILL: 'fill',
  FIT: 'fit',
  CROP: 'crop',
  TILE: 'tile',
} as const;

export const PREVIEW_TYPE = {
  FORM: 'form',
  FORM_FULL: 'form_full',
  CONFIRMATION: 'confirmation',
  LOGIN_SCREEN: 'login_screen',
} as const;

// TODO:: Improvement, The below data would be used in the future when metadata fields is expanded to include more info
export const FORM_FIELD_KEYS = {
  EMAIL: 'email',
  FIRST_NAME: 'first_name',
  LAST_NAME: 'last_name',
};

export const FORM_FIELD_NAME_VALUES = {
  EMAIL: 'Email address',
  FIRST_NAME: 'First name',
  LAST_NAME: 'Last name',
} as const;

export const FORM_ALIGNMENT = {
  CENTER: 'center',
  LEFT: 'left',
  RIGHT: 'right',
} as const;

export const CustomFieldTypes = {
  Text: 'text',
  Dropdown: 'dropdown',
  Checkbox: 'checkbox',
} as const;

export const RTF_BUTTON_TEXT_STYLE_VALUE = {
  BOLD: 'bold',
  REGULAR: 'regular',
  ITALIC: 'italic',
  UNDERLINE: 'underline',
} as const;

export const RTF_BUTTON_TYPES_VALUES = {
  OUTLINE: 'outline',
  SOLID: 'solid',
} as const;

export const REGISTRATION_FORM_MAX_CHARACTERS = 180;

export const BUTTON_ROLES = {
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
} as const;

export const BUTTON_TEXT_TYPE = {
  LOGIN: 'loginButtonText',
  REGISTER: 'registerButtonText',
  NEXT: 'nextButtonText',
  BACK: 'backButtonText',
} as const;

export const PREVIEW_DROPDOWN_ITEM_HEIGHT = 35;
export const PREVIEW_DROPDOWN_MAX_HEIGHT = 250;

export const KEY_CODES = {
  ENTER: 'Enter',
  ESCAPE: 'Escape',
  ARROW_UP: 'ArrowUp',
  ARROW_DOWN: 'ArrowDown',
} as const;

export const VIMEO_TERMS_OF_SERVICE_LINK = 'https://vimeo.com/terms';
export const VIMEO_PRIVACY_POLICY_LINK = 'https://vimeo.com/privacy';

export const PREVIEW_HTML_KEYS: PreviewHTML = {
  joinPageTitle: 'joinPageTitle',
  confirmationPageDescription: 'confirmationPageDescription',
  confirmationPageTitle: 'confirmationPageTitle',
  loginPageTitle: 'loginPageTitle',
} as const;

export const RESPONSE_KEYS_MAP = {
  logo: 'logo',
  background: 'background',
  customFields: 'customFields',
  hiddenFields: 'hiddenFields',
} as const;

export const LC_FIELDS = [
  'alignment',
  'background',
  'secondary_button_style',
  'confirmation_page_description',
  'confirmation_page_title',
  'primary_button_style',
  'is_event_date_set_to_calendar',
  'is_event_date_visible',
  'is_skippable',
  'join_page_title',
  'layout',
  'login_page_title',
  'logo',
  'metadata',
  'placement',
  'placement_timecode',
  'preset_name',
  'privacy_policy_url',
  'uri',
  'custom_fields',
  'hidden_fields',
  'email_lists',
  'calendar_links',
  'non_editable_text_style',
  'privacy_policy_version',
  'uuid',
  'has_active_crm_export_connection',
  'member_connections',
];

export const DROP_DOWN_POPOVER_PORTAL_ID = 'preview_drop_down_holder';

export const EVENT_FIELDS = 'schedule,user.uri,completedOn,status,title,stream_privacy';

export const LC_ENTITY_FIELDS = [
  'entity_info.user.uri',
  'entity_info.title',
  'entity_info.pictures',
  'entity_info.privacy',
  'entity_info.duration',
];

export const SHOWCASE_FIELDS = 'user.uri,name,pictures,privacy';

export const LC_PARAM_PREFIX = 'lc_param_';

export const URL_QUERY_PARAMS = {
  PASSWORD: 'password',
  HASHED_PASSWORD: 'hashed_password',
  UNLISTED_HASH: 'unlisted_hash',
} as const;

/** The params which will be filtered out by CG in PUT call*/
export const LC_URL_QUERY_PARAMS = {
  PASSWORD: `${LC_PARAM_PREFIX}${URL_QUERY_PARAMS.PASSWORD}`,
  UNLISTED_HASH: `${LC_PARAM_PREFIX}${URL_QUERY_PARAMS.UNLISTED_HASH}`,
} as const;

export const REGISTRATION_FULL_ERROR_CODE_MAP = {
  LIVE_EVENT_FULL: 2555,
  RESOURCE_IS_FULL: 3197,
} as const;

export const REGISTRATION_FULL_ERROR_CODE = Object.values(REGISTRATION_FULL_ERROR_CODE_MAP);

export const REGISTRANT_STATUS = 'is_blocked,uri';

export const REGISTRATION_TITLE_ID = 'registration-title-id';

export const PRIVACY_POLICY_VERSION = {
  V1: 1,
  V2: 2,
} as const;

export const DEFAULT_COUNTDOWN_TIMER = 5000;

export const PROVIDER_ID = {
  TYPE_MAILCHIMP: 1,
  TYPE_CAMPAIGN_MONITOR: 2,
  TYPE_CONSTANT_CONTACT: 3,
  TYPE_INFUSIONSOFT: 4,
  TYPE_HUBSPOT: 5,
  TYPE_CONSTANT_CONTACT_V3: 6,
  TYPE_MARKETO: 7,
  TYPE_SALESCLOUD: 8,
};

export const PROVIDER_ID_TO_SERVICE_ID_MAPPING = {
  [PROVIDER_ID.TYPE_MAILCHIMP]: 'mailchimp',
  [PROVIDER_ID.TYPE_CAMPAIGN_MONITOR]: 'campaign_monitor',
  [PROVIDER_ID.TYPE_CONSTANT_CONTACT]: 'constant_contact',
  [PROVIDER_ID.TYPE_INFUSIONSOFT]: 'infusionsoft',
  [PROVIDER_ID.TYPE_HUBSPOT]: 'hubspot',
  [PROVIDER_ID.TYPE_CONSTANT_CONTACT_V3]: 'constant_contact_v3',
  [PROVIDER_ID.TYPE_MARKETO]: 'marketo',
  [PROVIDER_ID.TYPE_SALESCLOUD]: 'salescloud',
};

export const LOGIN_ERROR_CODES = {
  NOT_REGISTERED: 2217,
  INVALID_EMAIL: 2204,
};

export const FEATURES = {
  CONFIRMATION_VIEW: 'confirmation_view',
} as const;

export const DOUBLE_GATE_BROADCAST_CHANNEL = 'lc_double_gate';

export const DOUBLE_GATE_MESSAGE_TYPE = {
  REQUEST_PARENT_LEAD_DETAILS: 'requestParentLeadDetails',
  RESPONSE_PARENT_LEAD_DETAILS: 'responseParentLeadDetails',
} as const;

export const API_ERROR_NAMES = {
  ABORT: 'AbortError',
} as const;

export const PARENT_ENTITY_TYPES = [ENTITY_TYPE.EVENT, ENTITY_TYPE.SHOWCASE] as const;

export const CHILD_ENTITY_TYPES = [ENTITY_TYPE.VIDEO] as const;
